import { Typography } from "@mui/material";
import styled from "styled-components";

export const STypography = styled(Typography)`
  && {
    font-size: 48px;
    font-weight: 500;
    font-size: Poppins Medium;
    color: var(--blue);
    margin-bottom: 66px;
  }
`;
